import React from 'react';
import { useFormikContext, Field } from 'formik';
import { FormattedMessage } from 'react-intl';
import { DropdownComponent } from '../../../../../components/prime-formik';
import { useSelector } from 'react-redux';

const SuperProfileRequiredLanguageProficiencyLanguageDropdown = ({ index, availableLanguages }) => {
  const {
    cldr: { localeDisplayName },
  } = useSelector((state) => state.i18n);
  const {
    values: { requiredLanguageProficiencies },
    errors,
    setFieldValue,
  } = useFormikContext();

  const hasError =
    errors.requiredLanguageProficiencies && errors.requiredLanguageProficiencies[index]
      ? !!errors.requiredLanguageProficiencies[index].language
      : false;

  const preferredLanguageOptions = availableLanguages.map((language) => {
    return {
      value: language,
      label: localeDisplayName(language),
    };
  });

  return (
    <div className="margin-bottom-0-5">
      <div className="flex-space-between">
        {' '}
        <FormattedMessage
          id="account.super-profiles.new.required-language-proficiencies.language"
          defaultMessage="Required language"
        >
          {(text) => (
            <label className="field-label" htmlFor={`requiredLanguageProficiencies.${index}.language`}>
              {text}
            </label>
          )}
        </FormattedMessage>
        <FormattedMessage id="select" defaultMessage="Select">
          {(text) => (
            <Field
              name={`requiredLanguageProficiencies.${index}.language`}
              component={DropdownComponent}
              filter
              className="right"
              value={requiredLanguageProficiencies[index].language}
              options={preferredLanguageOptions}
              hasError={hasError}
              onChange={(option) => setFieldValue(`requiredLanguageProficiencies.${index}.language`, option.value)}
              placeholder={`-- ${text} --`}
            />
          )}
        </FormattedMessage>
      </div>
    </div>
  );
};

export default SuperProfileRequiredLanguageProficiencyLanguageDropdown;
